import { Component, Inject, Input, Output, OnDestroy, EventEmitter } from '@angular/core';

import { packagesActions } from '@src/store/reducers/packagesReducer';
import { Store } from '@src/store';
import { consts } from '@src/constants/consts';
import _ from 'lodash';

@Component({
    selector: 'packages',
    template: require('./packages-ang7.html'),
    styles: [require('./_packages.scss')]
})
export class PackagesComponent implements OnDestroy {
    @Input() public isJobInProgress: boolean;
    @Input() public collapsed:boolean;
    @Input() public projectWithMetaData: any;
    @Input() public projectId: any;
    @Output() public onSelectPackageScript = new EventEmitter<any>();
    @Output() public onScriptTypeChanged = new EventEmitter<any>();
    @Output() public onClickPackage = new EventEmitter();
    @Output() public onNewPackage = new EventEmitter();
    @Output() public onScriptTypeMoved = new EventEmitter();
    @Output() public resetPackagesData = new EventEmitter<any>();

    public selectedItem: any;
    public packagesAdhoc: any;
    public selectedPackage: any;
    private hasPackages:any;
    private unsubscribe: any;

    constructor(
        private store: Store,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$scope') private $scope: any) {
            this.projectId = $stateParams.id;
            this.hasPackages = this.checkIfHasPackages();
    }
    async ngOnInit(){
        if(this.$stateParams.packageName !== '' && this.$stateParams.packageName !== null){
            this.store.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: this.projectId } }).then(x => {
                if(x){}
                let _packages = this.store.getState().packageManager.packages;
                this.selectedPackage = _packages.find(x => x.packageName = this.$stateParams.packageName)
             }); 
        }
     this.unsubscribe = this.store.subscribe(() => {
         let _packages = this.store.getState().packageManager.packages;
         this.hasPackages = _packages && _packages.length > 0;
         if (this.hasPackages) {
                    this.selectedPackage = this.selectedPackage
                    ? _packages?.find(item => item.id === this.selectedPackage.id)
                    : _.maxBy(_packages, "id");
         }
     });
     this.getPackagesData(false);

     this.$scope.$watch(() => this.isJobInProgress, (newVal, oldVal) => {
         if (newVal != undefined && oldVal != undefined && newVal != oldVal) {
             this.store.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: this.projectId } });
         }
     });
    }

    getPackagesData(needDataRefresh) {
        this.store.dispatch({ type: packagesActions.GET_PACKAGES, payload: { id: this.projectId } }).then((() => {
            this.$scope.$broadcast(consts.emitedEventsTypes.receivedPackagesData, { needDataRefresh });
        }));
    }

    checkIfHasPackages() {
        const packages = this.store.getState().packageManager.packages;
        return packages && packages.length > 0;
    }

    addPackage() {
        this.onNewPackage.emit();
    }

    onAdhocSettingChanged() {
        this.getPackagesData(true);
    }

    deletePackage() {
        const payload = { projectId: this.projectId, packageId: this.selectedPackage.id };
        this.store.dispatch({ type: packagesActions.DELETE_PACKAGE, payload: payload });
    }

    onUp(data, index) {
        this.switchOrder(data, index, index - 1,'up');
    }

    onDown(data, index) {
        this.switchOrder(data, index, index + 1,'down');
    }

    switchOrder(script, from, to,direction) {
        let scriptsIds = this.selectedPackage.scripts.filter(scr => {
            return scr.scriptType == script.scriptType;
        }).map((item) => item.scriptId);
        const newIndex = scriptsIds.indexOf(script.scriptId);
        from = newIndex;
        direction === 'up' ? to = newIndex-1: to = newIndex+1;
        if (scriptsIds.length > 1 && to !== -1 && to !== scriptsIds.length) {
            let tempId = scriptsIds[to];
            scriptsIds[to] = script.scriptId;
            scriptsIds[from] = tempId;
            const payload = { projectId: this.projectId, packageId: this.selectedPackage.id, ids: scriptsIds };
            this.store.dispatch({ type: packagesActions.REORDER_SCRIPTS, payload: payload });
        }
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-ang7.ts